//React components
import { useEffect, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';

//API
import { WarehouseFetchAPI } from '../../api/Warehouse';
//Internal components 
import add from '../img/icons/add-product.png'
//Modals 
import ModalNewUpdateWarehouse from './ModalWarehouse/ModalNewUpdateWarehouse';
import ErrorAlert from '../Alerts/ErrorAlert';
import Swal from 'sweetalert2';
const Warehouse = ({ selectedBranch, warehouses, getWarehouseByBrachoffice }) => {
    //We get the user data 
    let user = JSON.parse(localStorage.getItem('user'))
    let token = localStorage.getItem('x-access-token');
    //States 
    const [warehouseSelect, setWarehouseSelect] = useState({})
    const [showModalNewWarehouse, setShowModalNewWarehouse] = useState(false)
    const [userBranchoffices, setUserBranchs] = useState([]);

    //Function to delete warehouse
    const deleteWarehouse = async (warehouse_id) => {
        try {
            const response = await WarehouseFetchAPI.deleteWarehouse(warehouse_id, token)
            ErrorAlert('', 'Bodega eliminada corectamente', 'success')
            getWarehouseByBrachoffice(selectedBranch.id)
        } catch (err) {
            //If we have an error we show a error alert
            ErrorAlert(err.response.data.message, 'Error', 'error')
        }
    }

    //Function to toggle the disable a warehouse
    const toggleWarehouseActive = async (warehouse, is_enable) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: `¿Deseas ${is_enable === 1 ? 'desactivar' : 'activar'} la bodega ${warehouse.name}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await WarehouseFetchAPI.updateWarehouse(warehouse.id, {
                        is_enable: is_enable === 1 ? 0 : 1
                    }, token);
                    ErrorAlert('', `Bodega ${is_enable === 1 ? 'desactivada' : 'activada'} correctamente`, 'success');
                    getWarehouseByBrachoffice(selectedBranch.id);
                } catch (err) {
                    //If we have an error we show a error alert
                    ErrorAlert(err.response.data.message, 'Error', 'error');
                }
            }
        });
    }
    //Function to get the branchs of the user
    const viewWarehouse = () => {

        const list = warehouses.map(warehouse => (
            <>
                {warehouse.is_default == 0 ? <>
                    <Col xs="12" sm="6" md="6" lg="4" xl="3">

                        <article className={'border rounded-4 mt-4 p-2 position-relative'} >
                            <div className="d-flex justify-content-between ">
                                <div className="ms-1 me-auto d-inline-block">
                                    <div className='d-flex justify-content-between'>
                                        <div className="fw-bold text-truncate card-item-categorie-title">
                                            <span>{warehouse.name}</span>
                                        </div>
                                    </div>

                                    {/* <span >Precio: <b>${parseFloat(product.price).toFixed(2)}</b></span> */}
                                    <p className='text-secondary fw-light text-truncate card-item-categorie-description'>{warehouse.location}</p>
                                </div>
                            </div>
                            <div className='d-flex justify-content-between align-items-center rounded-3 mt-1'>

                                <div className='m-1'>

                                    <button className='btn btn-outline-primary pulse rounded-3 p-2 lh-1 border' onClick={() => (setWarehouseSelect(warehouse), setShowModalNewWarehouse(true))} >
                                        <i className="uil uil-edit-alt"></i>
                                    </button>

                                </div>
                                <div className='m-1'>

                                    <button className='btn btn-outline-danger pulse rounded-3 p-2 lh-1 border' onClick={() => deleteWarehouse(warehouse.id)} >
                                        <i className="uil uil-trash-alt"></i>
                                    </button>

                                </div>
                                {/* 🔄  Switch  */}
                                <Form.Check
                                    type="switch"
                                    id={`switch-${warehouse.id}`}
                                    checked={warehouse.is_enable === 1 ? true : false}         
                                    label={warehouse.is_enable === 0 ? 'Inactiva' : 'Activa'}
                                    onChange={() => toggleWarehouseActive(warehouse, warehouse.is_enable)}
                                    className="m-1"
                                />



                            </div>
                            <div className='position-absolute top-0 end-0 mt-1'>

                            </div>
                        </article>
                    </Col>
                </> : <></>}</>))
        return (list)
    }

    const viewWarehouseDefauld = () => {

        const list = warehouses.map(warehouse => (<>
            {warehouse.is_default == 1 ? <>
                <Col xs="12" sm="6" md="6" lg="4" xl="3">

                    <article className={'card-on shadow-sm rounded-4 mt-4 p-2 position-relative'} >
                        <div className="d-flex justify-content-between ">
                            <div className="ms-1 me-auto d-inline-block">
                                <div className='d-flex justify-content-between'>
                                    <div className="fw-bold text-truncate card-item-categorie-title">
                                        <span>{warehouse.name}</span>
                                    </div>


                                </div>
                                {/* <span >Precio: <b>${parseFloat(product.price).toFixed(2)}</b></span> */}
                                <p className='text-secondary fw-light text-truncate card-item-categorie-description'>{warehouse.location}</p>
                            </div>
                        </div>
                        <div className='d-flex justify-content-between align-items-center rounded-3 mt-1'>
                            <div className=' d-flex align-item-center justify-content-start gap-1'>
                            </div>

                        </div>
                        <div className='d-flex justify-constent-center align-items-center'>
                            <label className="icon-on pulse rounded-3 p-2 lh-1 border-on border-0">
                                {/* <img className='icon-options-cards' src={on} alt="restart" /> */}
                                <small className='ms-1 text-on fw-semibold'>Bodega por defecto </small>
                            </label>



                        </div>
                    </article>
                </Col>
            </> : <></>}</>))
        return (list)
    }

    //Hook to load the initial data 
    useEffect(() => {
        //We set the branchoffices of the user 
        setUserBranchs(user.branchoffices);
    }, []);


    return (
        <>
            <div className=''>

                <div className='d-flex justify-content-between m-3'>
                    <h4><i className="uil uil-database"></i> Bodegas </h4>

                </div>

                <div className='m-3'>
                    <div className="row gx-3 gy-2 align-items-center bg-white p-2 border-sp border">
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <div className="form-group">
                                <label htmlFor="input_from" className='fw-bold' >Sucursal: {selectedBranch.code == 0 ? <>Seleccione un sucursal</> : <h4 className="fw-bold text-primary">{selectedBranch.name}</h4>}</label>
                            </div>
                        </div>

                    </div>
                    <section className=''>
                        {selectedBranch.code != 0 ? <>
                            <div className="d-lg-flex justify-content-lg-between d-none mt-3">
                                <h4 className="fw-bold text-primary">Lista de bodegas </h4>

                            </div>

                            <div className="">
                                <Row>
                                    <Col xs="12" sm="6" md="6" lg="4" xl="3">
                                        <button className={'btn-add-product-list  rounded-4  pulse mt-4 py-4 w-100'}
                                            onClick={() => (setWarehouseSelect({}), setShowModalNewWarehouse(true))}
                                        >
                                            {/**Check user permition to create products */}
                                            <div className='d-flex justify-content-center '>
                                                <img src={add} alt="Add" />
                                            </div>

                                            <div className="text-center ">
                                                <span className='fw-bold'>Agregar una bodega </span>
                                            </div>
                                        </button></Col>
                                    {viewWarehouseDefauld()}
                                    {viewWarehouse()}
                                </Row>
                            </div></> : <></>}


                    </section>
                </div>
            </div>
            <ModalNewUpdateWarehouse showModalNewWarehouse={showModalNewWarehouse} setShowModalNewWarehouse={setShowModalNewWarehouse} selectedBranch={selectedBranch} warehouseSelect={warehouseSelect} getWarehouseByBrachoffice={getWarehouseByBrachoffice}></ModalNewUpdateWarehouse>
        </>
    );
}

export default Warehouse;
